import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams, useLocation, Link } from "react-router-dom";
import { slugify } from "../../helpers/utilities";
import {
  advertisement,
  middleBanner,
  individualBanner,
} from "../../assets/images";
import Facebook from "../../assets/images/articles/facebook.svg";
import web from "../../assets/images/articles/web.svg";
import ellipsis from "../../assets/images/articles/Ellipse.svg";
import pinterest from "../../assets/images/articles/pinterest.svg";
import Profile from "../../assets/images/articles/userProfile.png";
import social from "../../assets/images/articles/social.svg";
import Breadcrumbs from "../../components/common/Breadcrumbs";
import NewSocialShare from "../../components/common/NewSocialShare";
import SocialShare from "../../components/common/SocialShare";
import CommonIcon from "../../components/common/CommonIcon";
import { getAllArticles, getArticle } from "../../services/articleService";
import moment from "moment";

export default function NewArticlePage() {
  let location = useLocation();
  let { code } = location?.state || {};
  const [data, setData] = useState({});
  const [articleData, setArticleData] = useState();
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);
  const dispatch = useDispatch();
  const isPreloader = useSelector((state) => state.isPreloader);

  const onClick = () => {
    console.log("working");
  };

  const handleShareModalOpen = () => {
    setIsShareModalOpen(true);
  };

  const handleShareModalClose = () => {
    setIsShareModalOpen(false);
  };

  useEffect(() => {
    getArticle(code).then((res) => {
      if (res) {
        setData(res);
      }
    });
    getAllArticles().then((res) => {
      if (res) {
        setArticleData(res.data);
      }
    });
  }, [code]);

//  const  handleShareModalOpen = () => {
//     this.setState({
//       isShareModalOpen: true,
//     });
//   };

//   const handleShareModalClose = () => {
//     this.setState({
//       isShareModalOpen: false,
//     });
//   };
console.log("model",isShareModalOpen)
  return (
    <>
      <div
        id="NewArticle-Page"
        className={`${isPreloader ? "d-none" : "d-block"}`}
      >
        <section className="Article">
          <div className="container pt-16">
            {/* <div className="flex justify-between mb-3 mt-2">
              <Breadcrumbs
                subtitle="Article"
                subtitleLink="/article"
                extratitle="Home"
                extratitleLink="#"
                currentTile="Home"
              />
              <CommonIcon />
            </div> */}
            {/* <Breadcrumbs
            subtitle="Article"
            subtitleLink="/article"
            extratitle="Home"
            extratitleLink="#"
            currentTile="Home"
          /> */}

            {/* <SocialShare /> */}

            <div className="Article-div">
              <img src={individualBanner} alt="" />
            </div>
          </div>
        </section>

        <section className="Article-section">
          <div className="container">
            <div className="row">
              <div className="col-lg-7">
                <div className="Article-section-div">
                  <div className="shear-div">
                    <h1>{data?.title}</h1>
                    <span>
                      {data && data.createdAt
                        ? moment(data.createdAt).format("MMM DD YYYY")
                        : "Invalid Date"}
                    </span>
                    <div className="btn-div">
                      {/* <a href="#" className="btn btn1"> */}
                    
                      <button
                        className="btn btn1"
                        onClick={handleShareModalOpen}
                      >
                          Share
                          </button>
                        <SocialShare
                          opened={isShareModalOpen}
                          onClosed={handleShareModalClose}
                          shareLink={`https://dev.aceorientation.com/article/${slugify(
                            data?.title
                          )}`}
                        />
                 
                      {/* </a> */}
                      {/* <a href="#" className="btn btn2">
                        Tweet
                      </a>
                      <a href="#" className="btn btn3">
                        Pin It
                      </a> */}
                    </div>
                  </div>
                  <div className="table">
                    <h6>Table des matières</h6>
                    {data && data.content ? (
                      <div className="table-contant">
                        {data.content.map((item, index) => (
                          <a href="#" key={item.id}>
                            {item.title}
                          </a>
                        ))}
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
                <div className="Article-para-div">
                  <p>
                    Lorem ipsum dolor sit amet consectetur.{" "}
                    <a href="#">Tellus nunc eleifend</a> diam nibh sit in.
                    Turpis dui eget elementum suspendisse in. At imperdiet amet
                    hac nisl arcu consectetur facilisi enim a. Eu ultrices non
                    quis <a href="#">molestie</a> purus in. Accumsan nulla vel
                    nascetur ut dictum et mauris in.
                  </p>

                  <p>
                    Aliquet quis semper ut vulputate a rhoncus placerat odio
                    mauris. Pulvinar etiam magnis consectetur non sapien neque
                    pretium nunc. Nibh purus interdum quis non eget erat donec
                    tellus sem. Pretium viverra nunc turpis viverra{" "}
                    <a href="#">pharetra interdum.</a>
                  </p>

                  <img src={middleBanner} alt="" />

                  <p>
                    Phasellus vitae pellentesque posuere accumsan ac aliquam.
                    Suspendisse et scelerisque diam amet in sodales mattis ac
                    eget. Donec dui ultrices arcu eu nibh phasellus ut. Massa
                    quisque tristique quam commodo pretium facilisis quam.
                  </p>

                  <h6>Lorem ipsum dolor sit amet</h6>

                  <p>
                    Lorem ipsum dolor sit amet consectetur. Tellus nunc eleifend
                    diam nibh sit in. Turpis dui eget elementum suspendisse in.
                    At imperdiet amet hac nisl arcu consectetur facilisi enim a.
                    <a href="#">Eu ultrices non</a> quis molestie purus in.
                    Accumsan nulla vel nascetur ut dictum et mauris in.
                  </p>

                  <p>
                    <a href="#">
                      Aliquet quis semper ut vulputate a rhoncus placerat odio
                      mauris.
                    </a>
                    Pulvinar etiam magnis consectetur non sapien neque pretium
                    nunc. Nibh purus interdum quis non eget erat donec tellus
                    sem. Pretium viverra nunc turpis viverra pharetra interdum.
                  </p>

                  <p>
                    <a href="#">
                      Phasellus vitae pellentesque posuere accumsan ac aliquam.
                    </a>
                    Suspendisse et scelerisque diam amet in sodales mattis ac
                    eget. Donec dui ultrices arcu eu nibh phasellus ut. Massa
                    quisque tristique quam{" "}
                    <a href="#">commodo pretium facilisis quam.</a>
                  </p>

                  <h6>Lorem ipsum dolor sit amet</h6>

                  <p>
                    Lorem ipsum dolor sit amet consectetur. Tellus nunc eleifend
                    diam nibh sit in. Turpis dui eget elementum suspendisse in.
                    At imperdiet amet hac nisl arcu consectetur facilisi enim a.
                    Eu ultrices non quis <a href="#">molestie purus in.</a>
                    Accumsan nulla vel nascetur ut dictum et mauris in.
                  </p>

                  <p>
                    Aliquet quis semper ut vulputate a rhoncus placerat{" "}
                    <a href="#">odio mauris</a>. Pulvinar etiam magnis
                    consectetur non sapien neque pretium nunc. Nibh purus
                    interdum quis non eget erat donec tellus sem. Pretium
                    viverra nunc turpis viverra pharetra{" "}
                    <a href="#">interdum</a>.
                  </p>

                  <p>
                    Phasellus vitae pellentesque posuere accumsan ac{" "}
                    <a href="#">aliquam.</a> Suspendisse et scelerisque diam
                    amet in sodales mattis ac eget. Donec dui ultrices arcu eu
                    nibh phasellus ut.
                    <a href="#">Massa quisque</a> tristique quam commodo pretium
                    facilisis quam.
                  </p>
                </div>
              </div>
              <div className="col-lg-4 offset-1">
                <div className="blog">
                  <div className="blog-image">
                    <img src={Profile} alt="" />
                  </div>
                  <div className="blog-content-div">
                    <h5>{data?.author?.name}</h5>
                    <p>Lorem ipsum dolor sit amet consectetur</p>
                    {/* <div className="blog-icon">
                    <a href="#">
                      <img src={Facebook} alt="" />
                    </a>
                    <a href="#">
                      <img src={social} alt="" />
                    </a>
                    <a href="#">
                      <img src={pinterest} alt="" />
                    </a>
                    <a href="#">
                      <img src={web} alt="" />
                    </a>
                  </div> */}
                    <NewSocialShare author={data.author} />
                    <a href="#">Voir plus de cet auteur</a>
                  </div>
                </div>
                {/* <div className="part-article"> */}
                {/* <h6>Partagez cet article</h6>
                  <div className="part-article-cricle"> */}
                {/* <NewSocialShare/> */}
                {/* <a href="#">
                      <img src={Facebook} alt="" />
                    </a>
                    <a href="#">
                      <img src={social} alt="" />
                    </a>
                    <a href="#">
                      <img src={pinterest} alt="" />
                    </a> */}
                {/* </div> */}
                {/* </div> */}

                <div className="Article-populaire">
                  <h6>Article populaire </h6>
                  {data && articleData ? (
                    <ol>
                      {articleData.map((item, index) => (
                        <li key={item.publicId}>
                          <Link
                            to={{
                              pathname: `/articles/${slugify(item.title)}`,
                              state: { code: item.publicId, name: item.title },
                            }}
                          >
                            {item.title}
                          </Link>
                        </li>
                      ))}
                    </ol>
                  ) : (
                    <></>
                  )}

                  {/* <ol>
                  <li>Lorem ipsum dolor sit amet consectetur</li>
                  <li>Lorem ipsum dolor sit amet consectetur</li>
                  <li>Lorem ipsum dolor sit amet consectetur</li>
                  <li>Lorem ipsum dolor sit amet consectetur</li>
                  <li>Lorem ipsum dolor sit amet consectetur</li>
                  <li>Lorem ipsum dolor sit amet consectetur</li>
                  <li>Lorem ipsum dolor sit amet consectetur</li>
                  <li>Lorem ipsum dolor sit amet consectetur</li>
                  <li>Lorem ipsum dolor sit amet consectetur</li>
                  <li>Lorem ipsum dolor sit amet consectetur</li>
                </ol> */}
                </div>
                <div className="Publicité">
                  <p>Publicité</p>
                  <img src={advertisement} alt="" />
                </div>
                <div className="Publicité">
                  <p>Publicité</p>
                  <img src={advertisement} alt="" />
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
